<template>
  <Authenticated>
    <AccountsModal :show="accountShowModal" :account="currentAccount" @save="saveAccount" />
    <div>
      <button @click="showAccount(currentAccount)" class="action-buttons action-colour"><font-awesome-icon icon="plus" /> Add Account</button>
      <div class="actions">
        <h2 @click="getAccounts">Accounts</h2>
      </div>

      <div class="search-sort-layout">
        <form role="search" class="search">
          <input id="search" type="search" placeholder="Search..." autofocus required v-model="searchQuery" />
          <!-- <button @click="search()" type="submit">Go</button> -->
        </form>
        <!-- <div class="sort-dropdown">
          <h2>Sort:</h2>
          <select v-model="sortOption">
            <option value="" disabled selected>Default</option>
            <option value="name">Name</option>
            <option value="id">ID</option>
            <option value="htl">Balance(High to Low)</option>
            <option value="lth">Balance(Low to High)</option>
          </select>
        </div> -->
        <div class="sort-dropdown">
          <Carousel :items="sortOptions" :selected="sortOption" title="Sort By" @select-item="selectSort" />
        </div>
      </div>
      <h2 v-if="noResults">No Accounts Found</h2>
      <h2 v-if="searchQuery && searches.length">Searches:</h2>
      <ul v-if="searches.length" class="table wrapper layout content-gap">
        <template v-bind:key="search" v-for="search in searches">
          <li @click="showAccount(search)" class="modifierBox">
            <div class="box">
              <p>
                <span class="modifier-name">{{ search.key[1] }}</span>
                <span class="modifier-name">{{ search.key[0] }}</span>
                <span class="modifier-name"><CurrencyFormatter :value="search.value" :currency="currency"/></span>
              </p>
              <span></span>
            </div>
          </li>
        </template>
      </ul>

      <ul class="table wrapper layout content-gap">
        <template v-bind:key="account" v-for="account in accounts">
          <li @click="showAccount(account)" class="modifierBox">
            <div class="box">
              <p>
                <span class="modifier-name">{{ account.key[1] }}</span>
                <span class="modifier-name">{{ account.key[0] }}</span>
                <span class="modifier-name"><CurrencyFormatter :value="account.value" :currency="currency"/></span>
              </p>
              <span></span>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </Authenticated>
</template>
<script>
import Authenticated from "@/components/_layouts/Authenticated";
import { mapGetters } from "vuex";
import AccountsModal from "@/components/Accounts/AccountsModal";
import { api } from "@monolith/helpers";
import { Carousel, CurrencyFormatter } from "@monolith/components";

export default {
  name: "Accounts",
  components: {
    Authenticated,
    AccountsModal,
    Carousel,
    CurrencyFormatter,
  },
  data() {
    return {
      currentAccount: {},
      showAddAccount: false,
      accountRoute: false,
      showAccountModal: false,
      searchQuery: "",
      searches: [],
      noResults: false,
      sortOption: "",
      sortedAccounts: [],
      sortOptions: [
        { name: "Default", value: "default", selected: true },
        { name: "Name", value: "name" },
        { name: "ID", value: "id" },
        { name: "Desc Balance", value: "htl" },
        { name: "Asc Balance", value: "lth" },
      ],
    };
  },
  mounted() {
    if (this.$route.params.account) {
      this.accountRoute = true;
    }
    this.$store.commit("currPage", "accounts");
  },
  computed: {
    accountShowModal() {
      if (this.accountRoute) {
        return true;
      } else {
        return this.showAccountModal;
      }
    },
    ...mapGetters({
      modifier_sets: "modifier_sets",
      accounts: "accounts",
      currency: "currency",
    }),
  },
  watch: {
    sortOption: function (val) {
      if (val === "name") {
        this.accounts.sort((a, b) => {
          return a.key[1].localeCompare(b.key[1]);
        });
      } else if (val === "htl") {
        this.accounts.sort((a, b) => {
          return b.value - a.value;
        });
      } else if (val === "lth") {
        this.accounts.sort((a, b) => {
          return a.value - b.value;
        });
      } else if (val === "id") {
        this.accounts.sort((a, b) => {
          return a.key[0] - b.key[0];
        });
      }
    },
    searchQuery: function () {
      this.search();
    },
  },
  methods: {
    async search() {
      if (this.searchQuery.length > 1) {
        const search = await api.searchAccounts(this.searchQuery);
        let result = search.rows.map((acc) =>
          acc.key[2] == "id-name" ? { key: [acc.key[0], acc.key[1]], value: acc.value } : { key: [acc.key[1], acc.key[0]], value: acc.value }
        );
        !result.length ? (this.noResults = true) : (this.noResults = false);
        this.searches = result;
        document.querySelector(".sort-dropdown").style.display = "none";
      } else {
        this.noResults = false;
        this.searches = [];
        document.querySelector(".sort-dropdown").style.display = "flex";
      }
    },
    selectSort(val) {
      this.sortOption = val;
      if (val === "name") {
        this.accounts.sort((a, b) => {
          return a.key[1].localeCompare(b.key[1]);
        });
      } else if (val === "htl") {
        this.accounts.sort((a, b) => {
          return b.value - a.value;
        });
      } else if (val === "lth") {
        this.accounts.sort((a, b) => {
          return a.value - b.value;
        });
      } else if (val === "id") {
        this.accounts.sort((a, b) => {
          return a.key[0] - b.key[0];
        });
      } else if (val === "default") {
        return this.accounts;
      }
    },
    accountHistory(account) {
      this.$store.dispatch("accountHistory", account);
      //this.channel.push("account:history", id, name);
    },
    showAccount(account) {
      if (account.key) {
        this.accountHistory(account.key);
        this.currentAccount = {
          ID: account.key[0],
          name: account.key[1],
          value: account.value,
          new: true,
        };
      } else {
        this.currentAccount = {
          ID: "",
          name: "",
          doc_type: "credit",
          value: 0,
          date: new Date().toISOString(),
        };
      }

      this.showAccountModal = !this.showAccountModal;
    },
    saveAccount() {
      this.$store.dispatch("setHoldingAccount", this.currentAccount);
      // this.channel.push("account:doc", this.currentAccount);
      this.$notify({
        text: "Account: updated.",
        type: "success",
        duration: 1500,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

h2 {
  margin: 1rem;
}

.search-sort-layout {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem 0 0;

  .fa-sort {
    font-size: 2rem;
  }
  .sort-dropdown {
    display: flex;
    align-items: center;
    select {
      height: 3rem;
      font-size: 1.5rem;
      padding: 0.5rem;
      border-radius: 0.5rem;
      border: 1px solid var(--secondary-colour);
      background-color: var(--secondary-colour);
    }
  }

  #search{
    border: none;
    height: 3rem;
    margin-left: 1rem;
  }
}

@media only screen and (orientation: portrait) {
  .search-sort-layout {
    flex-direction: column;
    align-items: flex-start;
    padding: 0 0 0 1rem;

    .sort-dropdown {
      margin: auto;
      h2 {
        min-width: 0rem;
      }
    }
  }
}
</style>
